import { Component, OnInit, Input } from '@angular/core';

import { AlertsService } from 'src/modules/base/services/alerts.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { Router } from '@angular/router';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { SmartModalService, ModalSize } from 'src/modules/base/services/smart-modal.service';
import { ImageViewerComponent } from '../image-viewer/image-viewer.component';

@Component({
    selector: 'app-image-thumb',
    templateUrl: './thumb-viewer.component.html',
    standalone: false
})
export class ThumbViewerComponent implements OnInit {

  @Input() imagedata:any;
  public _currentdata:any = {};
  args: any;
  constructor(
    private alertService: AlertsService,
    private baseService: BaseService,
    private appService: AppService,
    private smartModal:SmartModalService,
    private router: Router) {
  }

  ngOnInit() {
    console.log(this.imagedata);
    this._currentdata.open = false;
    if(this.imagedata && this.imagedata.config != undefined && this.imagedata.data != undefined){
      if(this.imagedata.config.datasource != undefined){
        this.getImageUrl({...this.imagedata.config.datasource});
      }
      this.getThumbDimension();
      if(this.imagedata.config.title_key != undefined){
        this._currentdata.imageName = (this.imagedata.data[this.imagedata.config.title_key] != undefined)?this.imagedata.data[this.imagedata.config.title_key]:this.imagedata.config.title_key
      }else{
        this._currentdata.imageName = "";
      }
    }else{
      console.error("thumb config not correct");
    }
    this._currentdata.openInstance = this.smartModal.onModalClose();
    this._currentdata.openInstance.subscribe((ele)=>{
       this._currentdata.open = false;
    });
  }

  getImageUrl(datasource){
    datasource.application = (datasource.application != undefined)?datasource.application : this.appService.getApplication();
    datasource.queryId = (datasource.queryId != undefined)?datasource.queryId : "";
    datasource.resource = (datasource.resource != undefined)? (datasource.resource+'/image-response-entity') : "";
    datasource.args = (datasource.args != undefined)? this.baseService.buildDyanamicStr(datasource.args,{data:this.imagedata.data}) : "";
    datasource.args = this.baseService.checkargs(datasource.args)
    this.args = datasource.args
    this._currentdata.imageUrl = this.baseService.get_url(datasource.queryId,datasource.args,datasource.resource,datasource.application);
    //this._currentdata.imageUrl = "http://localhost:4599/assets/images/KareXpert_logo-n.png";
  }

  getThumbDimension(){
    if(this.imagedata.config.thumb != undefined){
      this._currentdata.thumbWidth = (this.imagedata.config.thumb.width != undefined)?this.imagedata.config.thumb.width: 50;
      this._currentdata.thumbHeight = (this.imagedata.config.thumb.height != undefined)?this.imagedata.config.thumb.height: 50;
    }else{
      this._currentdata.thumbWidth = 50;
      this._currentdata.thumbHeight = 50;
    }
  }

  viewLargeImage(){
    this._currentdata.open = true;
    setTimeout(()=>{
       this.smartModal.open(ImageViewerComponent, {data:{src:[ this._currentdata.imageUrl],fileData:[{name:this._currentdata.imageName}]}}, this._currentdata.imageName, ModalSize.Xl).subscribe(data => { }, err => { });
    });
  }

  ngOnDestroy(){
    if(this._currentdata.openInstance.unsubscribe != undefined){
      this._currentdata.openInstance.unsubscribe();
    }
  }
}
